/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type CoatTypeEnum = (typeof CoatTypeEnum)[keyof typeof CoatTypeEnum];

export const CoatTypeEnum = {
  short: 'short',
  long: 'long',
  complex: 'complex',
} as const;
